export default "__VITE_ASSET__DJ7dRheL__"